import styled from 'styled-components';
import { isTextRTL } from '../../utils/commonFunctions';

export const MessageListContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  margin-top: 20px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: 5px;
  }
  padding: 0 18px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 4px;
`;

export const ChatContainer = styled.div<{
  isSender?: boolean;
  sameAuthor?: boolean;
}>`
  display: flex;
  align-items: ${(props) => (props.isSender ? 'flex-end' : 'flex-start')};
  flex-direction: column;
  width: 100%;
  font-weight: 400;
  margin: ${(props) => `0 0 ${props.sameAuthor ? '0px' : '20px'} 0`};
`;

export const ChatDate = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  font-size: 14px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    font-size: 13px;
  }
`;

export const ChatBubble = styled.div<{ isSender: boolean; text: string }>`
  max-width: 75%;
  margin: 0 6px 0 6px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.isSender
      ? props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N0
        : props.theme.atlas.semantic.color.surface.default
      : props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  color: ${(props) => (props.isSender ? 'inherit' : 'white')};
  direction: ${(props) => (isTextRTL(props.text) ? 'rtl' : 'ltr')};
  font-size: 14px;
  padding: 12px;
  width: fit-content;
  white-space: pre-wrap;
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.035);
  word-break: break-word;
`;

export const ChatTime = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  font-size: 12px;
  margin: 6px;
`;
